export default "__VITE_ASSET__BgdmxeJw__"